import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rolling-window-dialog',
  templateUrl: './rolling-window-dialog.component.html',
  styleUrls: ['./rolling-window-dialog.component.css']
})
export class RollingWindowDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
